<template>
  <div id="app">
    <div>
<link rel='stylesheet' id='sb_instagram_styles-css'  href='/wp-content/plugins/instagram-feed/css/sb-instagram-2-2.min.css?ver=2.2' type='text/css' media='all' />
<link rel='stylesheet' id='wp-block-library-css'  href='/wp-includes/css/dist/block-library/style.min.css?ver=5.3.2' type='text/css' media='all' />
<link rel='stylesheet' id='contact-form-7-css'  href='/wp-content/plugins/contact-form-7/includes/css/styles.css?ver=5.1.6' type='text/css' media='all' />
<link rel='stylesheet' id='contact-form-7-confirm-css'  href='/wp-content/plugins/contact-form-7-add-confirm/includes/css/styles.css?ver=5.1' type='text/css' media='all' />
<link rel='stylesheet' id='ctf_styles-css'  href='/wp-content/plugins/custom-twitter-feeds/css/ctf-styles.min.css?ver=1.4.1' type='text/css' media='all' />
<link rel='stylesheet' id='jigyodan-style-css'  href='/wp-content/themes/jigyodan/style.css?ver=5.3.2' type='text/css' media='all' />
      <link href="/common/css/honbu.css" rel="stylesheet" type="text/css" media="screen,print" />
      <div id="search-table">
        <table>
          <tr>
            <td>エリア</td>
            <td><span>
              <input type="checkbox" id="tokyo" name="pref" value="東京都" title="東京都" @change="togglePref" v-model="pref">
              <label for="tokyo">東京都</label>
              </span> <span>
              <input type="checkbox" id="chiba"  name="pref" value="千葉県" title="千葉県" @change="togglePref" v-model="pref"> 
              <label for="chiba">千葉県</label>
              </span> <span>
              <input type="checkbox" id="kanagawa"  name="pref" value="神奈川県" title="神奈川県" @change="togglePref" v-model="pref">
              <label for="kanagawa">神奈川県</label>
              </span></td>
          </tr>
          <tr>
            <td class="tempth">施設名</td>
            <td><span>
              <input type="checkbox" id="radio4"  name="facility" value="石神井学園" title="石神井学園" @change="toggleFacility" v-model="facility">
              <label for="radio4" class="radiolabel">石神井学園</label>
              </span> <span>
              <input type="checkbox" id="radio5"  name="facility" value="小山児童学園" title="小山児童学園"   @change="toggleFacility" v-model="facility">
              <label for="radio5" class="radiolabel">小山児童学園</label>
              </span> <span>
              <input type="checkbox" id="radio6"  name="facility" value="船形学園" title="船形学園"  @change="toggleFacility" v-model="facility">
              <label for="radio6" class="radiolabel">船形学園</label>
              </span> <br />
              <span>
              <input type="checkbox" id="radio7"  name="facility" value="八街学園" title="八街学園"   @change="toggleFacility" v-model="facility">
              <label for="radio7" class="radiolabel">八街学園</label>
              </span> <span>
              <input type="checkbox" id="radio8"  name="facility" value="勝山学園" title="勝山学園"  @change="toggleFacility" v-model="facility">
              <label for="radio8" class="radiolabel">勝山学園</label>
              </span> <span>
              <input type="checkbox" id="radio9"  name="facility" value="片瀬学園" title="片瀬学園"   @change="toggleFacility">
              <label for="radio9" class="radiolabel">片瀬学園</label>
              </span> <br />
              <span>
              <input type="checkbox" id="radio10"  name="facility" value="七生福祉園" title="七生福祉園"   @change="toggleFacility" v-model="facility">
              <label for="radio10" class="radiolabel">七生福祉園</label>
              </span> <span>
              <input type="checkbox" id="radio11"  name="facility" value="東村山福祉園" title="東村山福祉園"   @change="toggleFacility" v-model="facility">
              <label for="radio11" class="radiolabel">東村山福祉園</label>
              </span> <span>
              <input type="checkbox" id="radio12"  name="facility" value="希望の郷 東村山" title="希望の郷 東村山"   @change="toggleFacility" v-model="facility">
              <label for="radio12" class="radiolabel">希望の郷 東村山</label>
              </span> <br />
              <span>
              <input type="checkbox" id="radio13"  name="facility" value="千葉福祉園" title="千葉福祉園"   @change="toggleFacility" v-model="facility">
              <label for="radio13" class="radiolabel">千葉福祉園</label>
              </span> <span>
              <input type="checkbox" id="radio14"  name="facility" value="日野療護園" title="日野療護園"   @change="toggleFacility" v-model="facility">
              <label for="radio14" class="radiolabel">日野療護園</label>
              </span> <span>
              <input type="checkbox" id="radio15"  name="facility" value="八王子福祉園" title="八王子福祉園"   @change="toggleFacility" v-model="facility">
              <label for="radio15" class="radiolabel">八王子福祉園</label>
              </span> <br />
              <span>
              <input type="checkbox" id="radio16"  name="facility" value="事務局" title="事務局"   @change="toggleFacility" v-model="facility">
              <label for="radio16" class="radiolabel">事務局</label>
              </span></td>
          </tr>
          <tr class="tr_color">
            <td class="tempth">職種</td>
            <td class="tr_color"><span>
              <input type="checkbox" id="radio17"  name="job_type" value="福祉" title="福祉" @change="toggleJobType" v-model="jobType">
              <label for="radio17" class="radiolabel">福祉</label>
              </span> <span>
              <input type="checkbox" id="radio18"  name="job_type" value="看護師・准看護師" title="看護師・准看護師" @change="toggleJobType" v-model="jobType">
              <label for="radio18" class="radiolabel">看護師・准看護師</label>
              </span> <br />
              <span>
              <input type="checkbox" id="radio19"  name="job_type" value="栄養士" title="栄養士" @change="toggleJobType" v-model="jobType">
              <label for="radio19" class="radiolabel">栄養士</label>
              </span> <span>
              <input type="checkbox" id="radio20"  name="job_type" value="心理" title="心理" @change="toggleJobType" v-model="jobType">
              <label for="radio20" class="radiolabel">心理</label>
              </span> <span>
              <input type="checkbox" id="radio21"  name="job_type" value="事務" title="事務" @change="toggleJobType" v-model="jobType">
              <label for="radio21" class="radiolabel">事務</label>
              </span> <br />
              <span>
              <input type="checkbox" id="radio22"  name="job_type" value="調理員" title="調理員" @change="toggleJobType" v-model="jobType">
              <label for="radio22" class="radiolabel">調理員</label>
              </span> <span>
              <input type="checkbox" id="radio23"  name="job_type" value="医師" title="医師" @change="toggleJobType" v-model="jobType">
              <label for="radio23" class="radiolabel">医師</label>
              </span> <span>
              <input type="checkbox" id="radio24"  name="job_type" value="その他" title="その他" @change="toggleJobType" v-model="jobType">
              <label for="radio24" class="radiolabel">その他</label>
              </span></td>
          </tr>
        </table>
        <input type="button" value="この条件で検索する" id="search-submit" @click="refreshSearch">
      </div>
    </div>
    <div class="wrap2 m-t30">
      <p class="lead-02">{{ items | countItems }}件見つかりました。</p>
      <div id="search-result">
        <table>
          <tr data-href="#" tabindex="0">
            <th>施設名</th>
            <th>雇用形態</th>
            <th>職種</th>
            <th></th>
          </tr>
          <tr v-for="(item, key) in getItems" :key="key" :data-href="item.link" :data-date="item.date" tabindex="0" @click="link">
            <td><span>{{ item.data.place }}</span></td>
            <td><span>{{ item.data.status }}</span></td>
            <td><span>{{ item.data.type }}</span></td>
            <td><span>詳細へ</span></td>
          </tr>
        </table>
        <paginate
        :value="currentPage"
    :page-count="getPageCount"
    :page-range="3"
    :margin-pages="2"
    :click-handler="clickCallback"
    :prev-text="'<'"
    :next-text="'>'"
    :container-class="'pager-wrap'"
    :prev-link-class="'prev page-numbers'"
    :next-link-class="'next page-numbers'"
    :page-link-class="'page-numbers'">
  </paginate>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import Paginate from 'vuejs-paginate'
Vue.component('paginate', Paginate)

export default {
  name: 'App',
  filters: {
    countItems (v) {
      return v.length
    }
  },
  components: {
    
  },
  methods: {
    clickCallback: function (pageNum) {
      this.$store.commit('setCurrentPage',Number(pageNum))
      this.$store.commit('saveCondition')
    },
    togglePref: function (el){
      this.$store.commit('togglePref', el.srcElement)
    },
    toggleFacility: function (el){
      this.$store.commit('toggleFacility', el.srcElement)
    },
    toggleJobType: function (el){
      this.$store.commit('toggleJobType', el.srcElement)
    },
    refreshSearch: function (){
      this.$store.commit('setSavedCurrentPage',Number(1))
      this.$store.commit('setCurrentPage',Number(1))
      this.$store.commit('saveCondition');
      this.$store.dispatch('commitDataSet');
    },
    link: function (el){
      console.log(el.srcElement);
      let pEl = el.srcElement.parentNode;
      while(pEl.parentNode){
        console.log(pEl)
        if (pEl.localName === 'tr') {
          location.href = pEl.dataset.href;
          break;
        } else {
          pEl = pEl.parentNode;
        }
      }
    }
  },
  computed: {
    ...mapState([
      'items',
      'perPage',
      'currentPage',
      'pref',
      'jobType',
      'facility'
    ]),
    getItems: function() {
      let current = this.currentPage * this.perPage;
      let start = current - this.perPage;
      return this.items.slice(start, current);
    },
    getPageCount: function() {
      return Math.ceil(this.items.length / this.perPage);
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
li.active .page-numbers{
  background-color: #fabe00;
}
#search-table label{
  margin-left:8px;
}
</style>
